import { FileText } from 'lucide-react'

/** Where a dated line comes from: a small mono tag, as on the founder's own record. */
export function SourceTag({ children }: { children: string }) {
  return (
    <span className="inline-flex items-center gap-1 rounded-[5px] border border-emerald-500/35 px-2 py-0.5 font-mono text-[10px] uppercase tracking-wide text-emerald-500">
      <FileText className="size-3" />
      {children}
    </span>
  )
}
